/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IRDeleteIRResponse } from "./IRDeleteIRResponse";

export type IRDeleteIRResponseApiRespoonse = {
  data?: IRDeleteIRResponse;
  status?: IRDeleteIRResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace IRDeleteIRResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
